import store from '@/store';

export function hasAuth(state, key) {
  const auth = store.state.user.auth[state] || [];
  // 判断是否是超级管理员
  if (auth.includes('*')) {
    return true;
  }
  var status = false;
  if (!key) {
    return;
  }
  key.split('|').forEach((ele) => {
    if (auth.includes(ele.trim())) {
      status = true;
    }
  });
  return status;
}

function removeEl(el) {
  try {
    el.parentNode && el.parentNode.removeChild(el);
  } catch (e) {
    // e
  }
}

export default {
  // 指令第一次绑定到元素时
  bind: (el, {arg, value}) => {
    el.style.display = 'none';

    if (!hasAuth(arg, value)) {
      removeEl(el);
    } else {
      el.style.display = '';
    }
  },

  // 被绑定元素插入父节点时
  inserted: (el, {arg, value}) => {
    if (!hasAuth(arg, value)) {
      removeEl(el);
    }
  },
  update: (el, {arg, value}) => {
    if (!hasAuth(arg, value)) {
      removeEl(el);
    }
  },
  unbind: (el) => {
    if (el && el.parentNode) {
      removeEl(el);
    }
    el = null;
  }
};
